<template>
  <v-form>
    <ticket-info-panel
      :ticket-data="ticketData"
      :anexos="imagensEDocumentos"
      :formularios-respostas="formulariosRespostas"
      :get-tickets="getTickets"
      :get-tickets-and-select-first="getTicketsAndSelectFirst"
      :atualizar-tipo-de-solicitacao="atualizarTipoDeSolicitacao"
      :reset-ticket-data-e-get-mensagens="resetTicketDataEGetMensagens"
      :ticket-esta-finalizado="ticketEstaFinalizado"
      :ticket-esta-resolvido="ticketEstaResolvido"
    />

    <v-expansion-panels
      :value="expansionPanelsQueDevemAbrirPorDefault"
      multiple
      focusable
    >
      <secao-default-dados-do-solicitante-expansion-panel
        v-if="secaoDefaultDadosDoSolicitante.visivelAgente"
        :solicitante-data="ticketData.solicitante"
        :editavel="secaoDefaultDadosDoSolicitante.editavelAgente"
        :ticket-esta-finalizado="ticketEstaFinalizado"
        @refetch-data="getTicketById"
        @alterar-dados-solicitante="receberDadosDoSolicitante"
      />

      <template v-for="(item, index) in secoesPersonalizadas">
        <secao-personalizada-expansion-panel
          v-if="item.visivelAgente"
          :key="index"
          :ticket-id="ticketData.id"
          :formulario-id="item.idFormulario"
          :qtd-colunas="item.colunas"
          :titulo="item.titulo"
          :empresa-nome="empresaNome"
          :editavel="item.editavelAgente"
          :elementos="item.elementos"
          :impressao-disponivel="item.visivelAgenteImpressao"
          :solicitante-data="ticketData.solicitante"
          @update-ticket="updateTicket"
          @atualizar-respostas="receberRespostasFormularios"
        />
      </template>

      <secao-default-mensagens-expansion-panel
        v-if="secaoDefaultMensagens.visivelAgente"
        :ticket-data="ticketData"
        :mensagens="mensagens"
        :template-whats-app24-horas-props="templateWhatsApp24HorasProps"
        :editavel="secaoDefaultMensagens.editavelAgente"
        :ticket-esta-finalizado="ticketEstaFinalizado"
        :pode-gravar-audio="podeGravarAudio"
        :pode-responder-mensagem="podeResponderMensagem"
        @refetch-data="handleChatRefetchData"
      />
    </v-expansion-panels>
  </v-form>
</template>

<script>
import { storeToRefs } from 'pinia'
import TicketInfoPanel from './TicketInfoPanel.vue'
import SecaoDefaultDadosDoSolicitanteExpansionPanel from './secoes/SecaoDefaultDadosDoSolicitanteExpansionPanel.vue'
import SecaoPersonalizadaExpansionPanel from './secoes/SecaoPersonalizadaExpansionPanel.vue'
import SecaoDefaultMensagensExpansionPanel from './secoes/SecaoDefaultMensagensExpansionPanel.vue'
import useAtendimentoTicket from '@/composables/useAtendimentoTicket'
import useTicketMensagens from '@/composables/useTicketMensagens'
import useEmpresaData from '@/composables/useEmpresaData'
import useTicketWhatsAppOuBotAlerta24Horas from '@/composables/useTicketWhatsAppOuBotAlerta24Horas'
import useAtendimentoStore from '@/store/atendimento'

export default {
  emits: ['refetch-slas-contadores'],

  components: {
    TicketInfoPanel,
    SecaoDefaultDadosDoSolicitanteExpansionPanel,
    SecaoPersonalizadaExpansionPanel,
    SecaoDefaultMensagensExpansionPanel,
  },

  props: {
    getTickets: {
      type: Function,
      required: true,
    },
    getTicketsAndSelectFirst: {
      type: Function,
      required: true,
    },
  },

  setup(props, { emit }) {
    const { ticketSelecionadoId } = storeToRefs(useAtendimentoStore())

    const {
      ticketData,
      imagensEDocumentos,
      formulariosRespostas,
      secaoDefaultDadosDoSolicitante,
      secoesPersonalizadas,
      secaoDefaultMensagens,
      ticketEstaFinalizado,
      ticketEstaResolvido,
      podeGravarAudio,
      podeResponderMensagem,
      expansionPanelsQueDevemAbrirPorDefault,
      getTicketById,
      getTicketEAnexos,
      receberDadosDoSolicitante,
      atualizarTipoDeSolicitacao,
      receberRespostasFormularios,
      resetTicketData,
      updateTicket,
    } = useAtendimentoTicket(ticketSelecionadoId)

    const { mensagens, getMensagens } = useTicketMensagens(ticketSelecionadoId)
    const { templateWhatsApp24HorasProps } = useTicketWhatsAppOuBotAlerta24Horas(ticketData, mensagens)
    const { empresaNome } = useEmpresaData()

    async function resetTicketDataEGetMensagens() {
      await resetTicketData()
      await getMensagens()
      emit('refetch-slas-contadores')
    }

    async function handleChatRefetchData() {
      await getTicketEAnexos()
      await getMensagens()
      props.getTickets()
      emit('refetch-slas-contadores')
    }

    return {
      ticketData,
      imagensEDocumentos,
      formulariosRespostas,
      secaoDefaultDadosDoSolicitante,
      secoesPersonalizadas,
      secaoDefaultMensagens,
      ticketEstaFinalizado,
      ticketEstaResolvido,
      podeGravarAudio,
      podeResponderMensagem,
      expansionPanelsQueDevemAbrirPorDefault,
      getTicketById,
      receberDadosDoSolicitante,
      atualizarTipoDeSolicitacao,
      updateTicket,
      receberRespostasFormularios,

      mensagens,
      templateWhatsApp24HorasProps,
      empresaNome,

      resetTicketDataEGetMensagens,
      handleChatRefetchData,
    }
  },
}
</script>
